<template>
  <div class="login-card__name-card">
    <div class="login-card__title-box">
      <h1 class="login-card__title">{{ trans.get('auth.card.name.header') }}</h1>
      <p class="login-card__title-desc"> {{ trans.get('auth.card.name.subheader') }}</p>
    </div>
    <div>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="form-row">
            <div class="form-group col-12">
              <ValidationProvider name="name" rules="required|min:4|max:12|alpha_num" v-slot="{ errors }" mode="eager">
                <label for="name"></label>
                <input
                  type="text" id="name"
                  class="input-text input-text__underline"
                  maxlength="12"
                  v-model="form.name"
                  :placeholder="trans.get('auth.card.fields.name')"
                >
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
              <p class="login-card__desc">{{ trans.get('auth.card.name.description') }}</p>
            </div>
          </div>
          <button type="submit" class="button button__fill button--w-100 mt-5 text--smedium">{{ trans.get('auth.card.buttons.continue') }}</button>
        </form>
      </ValidationObserver>

      <button type="button" class="button button__link button__link--underline mt-3" @click="logout">{{ trans.get('auth.card.buttons.logout') }}</button>
    </div>
  </div>

</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';

export default {
  components: { ValidationObserver, ValidationProvider },
  props: ['swapComponent', 'form'],
  data: () => ({}),
  mounted() {
    this.$store.dispatch('analytics/gtagEvent', {
      event: 'soi',
      p: {
        'event_category': 'User Registration',
        'event_label': 'SOI Registration'
      }
    });
  },
  methods: {
    onSubmit() {
      if (this.form.id) {
        axios
          .put(zRoute('register.update'), { name: this.form.name })
          .then((response) => {
            if (response.data.status === 'success') {
              // this.swapComponent('auth-gender-card');
              this.swapComponent('auth-preferences-card');
            } else {
              this.$refs.form.setErrors({ name: [this.trans.get('auth.card.data_update_failed')] });
            }
          })
          .catch((error) => {
            const errors = error.response.data.errors;

            if (error.response.status === 422) {
              this.$refs.form.setErrors(errors);
            }
          });
      } else {
        axios
          .post(zRoute('ajax.register.name'), { name: this.form.name })
          .then((response) => {
            if (response.data.status === 'success') {
              // this.swapComponent('auth-gender-card');
              this.swapComponent('auth-preferences-card');
            } else {
              this.$refs.form.setErrors({ name: [this.trans.get('auth.card.data_update_failed')] });
            }
          })
          .catch((error) => {
            const errors = error.response.data.errors;

            if (error.response.status === 422) {
              this.$refs.form.setErrors(errors);
            }
          });
      }
    },
    logout() {
      axios
        .post(zRoute('logout'))
        .then(() => {
          this.$emit('reset-form');
          this.swapComponent('auth-welcome-card');
        });
    },
    async refreshCSRFToken() {
      axios
        .get(zRoute('ajax.csrf_token'))
        .then(response => {
          const token = response.data.csrfToken;
          document.querySelector('meta[name=csrf-token]').setAttribute('content', token);
          window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
        });
    },
  },
  activated() {
    this.refreshCSRFToken();
    this.$emit('update:progress', 25);
  },
};
</script>
<style scoped>
</style>
